import React, { useState, useEffect } from "react";
import "./../../../../assets/css/purchase/form.css";

// Components
import Breadcrumbs from "../../../components/Breadcrumbs";
import ArModal from "../../../components/Modal/ArModal";
import InvoiceModal from "../../../components/Modal/InvoiceModal";
import Summary from "../../../components/Footer/Summary";
import FormAction from "../../../components/Actions/FormAction";
import DatePicker from "../../../components/DatePicker";

// Model
import { invMasterModel } from "../../../../model/SellProducts/InvMasterModel";

import {
  getData,
  getDataWithComp,
  formatCurrency,
  parseCurrency,
  getAlert,
} from "../../../../utils/SamuiUtils";

import {
  setCreateDateTime,
  getCreateDateTime,
  formatDate,
} from "../../../../utils/DateUtils";

import {
  InvoiceHandleSubmit,
  InvoiceHandleUpdate,
} from "../../../../utils/InvoiceUtils";

const Form = ({ callInitialize, mode, setMode, name, docNo }) => {
  const [formMasterList, setFormMasterList] = useState(invMasterModel());
  const [formDetailList, setFormDetailList] = useState([]);
  const [whDataList, setWhDataList] = useState([]);
  const [soDataList, setSoDataList] = useState([]);
  const [arDataList, setArDataList] = useState([]);
  const [invDataList, setInvDataList] = useState([]);

  // การคำนวณเงิน
  const [selectedDiscountValueType, setSelectedDiscountValueType] =
    useState("2");
  const [totalPrice, setTotalPrice] = useState(0);
  const [receiptDiscount, setReceiptDiscount] = useState(0);
  const [subFinal, setSubFinal] = useState(0);
  const [grandTotal, setGrandTotal] = useState(0);
  const [isVatChecked, setIsVatChecked] = useState(false);
  const [vatAmount, setVatAmount] = useState(0);

  // ออกใบกำกับภาษีของ ใบวางบิล หรือ ใบขาย
  const [dataType, setDataType] = useState(""); // BI = ใบวางบิล, SO = ใบขาย

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  // คำนวณ item ที่จะแสดงในแต่ละหน้า
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = formDetailList.slice(indexOfFirstItem, indexOfLastItem);

  // ฟังก์ชันสำหรับการเปลี่ยนหน้า
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    const whDataList = await getDataWithComp(
      "Tb_Set_WH",
      `AND Flag_Vansale = 'N' AND WH_Status = 'Y' ORDER BY Flag_Vansale, WH_Name ASC`
    );
    if (whDataList && whDataList.length > 0) {
      setWhDataList(whDataList);
    }

    const soDataList = await getDataWithComp(
      "API_0701_SO_H",
      "AND Doc_Status <> 13 AND Doc_INV_No IS NULL AND Doc_Is_PickingList <> 0 AND IsVat = 1 ORDER BY Doc_No DESC"
    );
    if (soDataList && soDataList.length > 0) {
      console.debug(soDataList);
      setSoDataList(soDataList);
    }

    const arDataList = await getDataWithComp(
      "Tb_Set_AR",
      "ORDER BY AR_Code ASC"
    );
    if (arDataList && arDataList.length > 0) {
      setArDataList(arDataList);
    }

    const invDataList = await getDataWithComp(
      "API_1301_BL_H",
      "AND Doc_Status <> 13 AND Doc_INV_No IS NULL ORDER BY Doc_No DESC"
    );
    if (invDataList && invDataList.length > 0) {
      setInvDataList(invDataList);
    }

    // สำหรับ View เข้ามาเพื่อแก้ไขข้อมูล
    if (mode === "U") {
      await getModelByNo(arDataList);
    }
  };

  const getModelByNo = async (arDataList) => {
    try {
      const fromDatabase = await getDataWithComp(
        "INV_H",
        `AND Doc_No = '${docNo}'`
      );

      if (!fromDatabase) {
        throw new Error("ไม่พบข้อมูลเอกสาร");
      }

      // ค้นหาข้อมูลผู้ขายด้วย AR_ID
      const fromViewAr = arDataList.find(
        (ap) => ap.AR_Id === fromDatabase[0].AR_ID
      );

      if (!fromViewAr) {
        throw new Error("ไม่พบข้อมูลลูกค้า");
      }

      const data = fromDatabase[0];

      setIsVatChecked(data.BL_Is_Vat === 1 ? true : false);

      setDataType(data.Doc_Is_INV_From === 1 ? "SO" : "BI");

      // ดักเงื่อนไขว่าเป็น ใบวางบิล หรือ ใบขาย
      if (data.Doc_Is_INV_From === 1) {
        const soData = await getData(
          "API_0701_SO_H",
          `Doc_Id = '${data.Ref_DocID}'`
        );
        if (soData && soData.length > 0) {
          await onRowSelectSo(soData[0]);
        } else {
          getAlert("FAILED", "ไม่พบข้อมูลใบขาย");
        }
      } else if (data.Doc_Is_INV_From === 2) {
        const billData = await getData(
          "API_1301_BL_H",
          `Doc_Id = '${data.Ref_DocID}'`
        );
        if (billData && billData.length > 0) {
          await onRowSelectInv(billData[0]);
        } else {
          getAlert("FAILED", "ไม่พบข้อมูลใบวางบิล");
        }
      } else {
        getAlert("FAILED", "ไม่พบข้อมูลเอกสาร");
      }

      setFormMasterList({
        docId: data.Doc_Id,
        compId: data.Comp_Id,
        docNo: data.Doc_No,
        docDate: data.Doc_Date || null,
        docStatus: data.Doc_Status,
        docStatusTransport: data.Doc_Status_Transport,
        docStatusReceive: data.Doc_Status_Receive,
        docStatusPaid: data.Doc_Status_Paid,
        docStatusPaidType: data.Doc_Status_Paid_Type,
        docCode: data.Doc_Code,
        docType: data.Doc_Type,
        docFor: data.Doc_For,
        docIsPickingList: data.Doc_Is_PickingList,
        docIsInv: data.Doc_Is_INV,
        docInvNo: data.Doc_INV_No,
        docIsInvFrom: data.Doc_Is_INV_From,
        refDocId: data.Ref_DocID,
        refDoc: data.Ref_Doc,
        refDocDate: data.Ref_DocDate || null,
        refProjectID: data.Ref_ProjectID,
        refProjectNo: data.Ref_ProjectNo,
        transportType: data.Transport_Type,
        docRemark1: data.Doc_Remark1,
        docRemark2: data.Doc_Remark2,
        arID: data.AR_ID,
        arCode: data.AR_Code,
        arName: fromViewAr.AR_Name,
        docDueDate: formatDate(data.Doc_DueDate || null),
        actionHold: data.Action_Hold,
        discountValue: data.Discount_Value,
        discountValueType: data.Discount_Value_Type,
        discountCash: data.Discount_Cash,
        discountCashType: data.Discount_Cash_Type,
        discountTransport: data.Discount_Transport,
        discountTransportType: data.Discount_Transport_Type,
        isVat: data.IsVat,
        docSEQ: data.Doc_SEQ,
        creditTerm: data.CreditTerm,
        creditTerm1Day: data.CreditTerm1Day,
        creditTerm1Remark: data.CreditTerm1Remark,
        creditTerm2Remark: data.CreditTerm2Remark,
        accCode: data.ACC_Code,
        empName: data.EmpName,
        createdDate: setCreateDateTime(data.Created_Date),
        createdByName: data.Created_By_Name,
        createdById: data.Created_By_Id,
        updateDate: getCreateDateTime(),
        updateByName: window.localStorage.getItem("name"),
        updateById: window.localStorage.getItem("emp_id"),
        approvedDate: setCreateDateTime(data.Approved_Date),
        approvedByName: data.Approved_By_Name,
        approvedById: data.Approved_By_Id,
        cancelDate: setCreateDateTime(data.Cancel_Date),
        cancelByName: data.Cancel_By_Name,
        cancelById: data.Cancel_By_Id,
        approvedMemo: data.Approved_Memo,
        printedStatus: data.Printed_Status,
        printedDate: setCreateDateTime(data.Printed_Date),
        printedBy: data.Printed_By,

        // ใช้สำหรับแสดงเฉยๆ
        arAdd1: fromViewAr.AR_Add1,
        arAdd2: fromViewAr.AR_Add2,
        arAdd3: fromViewAr.AR_Add3,
        arProvince: fromViewAr.AR_Province,
        arZipcode: fromViewAr.AR_Zipcode,
        arTaxNo: fromViewAr.AR_TaxNo,
      });
    } catch (error) {
      getAlert("FAILED", error.message || error);
    }
  };

  const handleCheckboxChange = (event) => {
    const { name } = event.target;
    setSelectedDiscountValueType(
      selectedDiscountValueType === name ? null : name
    );
  };

  const handleChangeMaster = (e) => {
    const { name, value } = e.target;
    // อัปเดตค่าใน formMasterList
    setFormMasterList((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleChangeDateMaster = (value, name) => {
    setFormMasterList((prev) => ({
      ...prev,
      [name]: value ? value.format('YYYY-MM-DD') : null,
    }));
  };

  const handleFocus = (index, field) => {
    const updatedList = [...formDetailList];
    updatedList[index][field] =
      parseCurrency(updatedList[index][field].replace(/,/g, "")) || 0;
    setFormDetailList(updatedList);
  };

  const handleBlur = (index, field, value) => {
    const numericValue = parseCurrency(value.replace(/,/g, "")) || 0;
    const formattedValue = formatCurrency(numericValue);

    const updatedList = [...formDetailList];
    updatedList[index][field] = formattedValue;
    setFormDetailList(updatedList);
  };

  // SET AR
  const [showArModal, setShowArModal] = useState(false);
  const handleArShow = () => setShowArModal(true);
  const handleArClose = () => setShowArModal(false);
  const onRowSelectAr = (arSelected) => {
    try {
      setFormMasterList({
        ...formMasterList,
        arID: arSelected.AR_Id,
        arCode: arSelected.AR_Code,
        arName: arSelected.AR_Name,
        arAdd1: arSelected.AR_Add1,
        arAdd2: arSelected.AR_Add2,
        arAdd3: arSelected.AR_Add3,
        arProvince: arSelected.AR_Province,
        arZipcode: arSelected.AR_Zipcode,
        arTaxNo: arSelected.AR_TaxNo,
      });

      handleArClose(); // ปิด modal หลังจากเลือก
    } catch (error) {
      getAlert("FAILED", error);
    }
  };

  // SET INVOICE & SET SO
  const [showInvModal, setShowInvModal] = useState(false);
  const handleInvShow = () => setShowInvModal(true);
  const handleInvClose = () => setShowInvModal(false);
  const onRowSelectInv = async (invSelected) => {
    try {
      // SET ตัวแปรสำหรับระบุประเภทการเลือก
      setDataType("BI");

      // ล้างข้อมูลเก่าก่อน
      setFormDetailList([]);

      setFormMasterList({
        ...formMasterList,
        refDocId: invSelected.Doc_Id,
        refDoc: invSelected.Doc_No,
        refDocDate: invSelected.Doc_Date,
      });

      if (parseCurrency(invSelected.BL_Is_Vat) === 1) {
        setIsVatChecked(true);
      }

      // อัปเดต formDetailList
      setFormDetailList([
        {
          docDate: invSelected.Doc_Date,
          docNo: invSelected.Doc_No,
          docName: `ใบขายของ ${invSelected.Comp_Name_TH}`,
          itemQty: 1,
          itemTotal: invSelected.BL_Total,
        },
      ]);

      handleInvClose();
    } catch (error) {
      getAlert("FAILED", error.message || error);
    }
  };
  const onRowSelectSo = async (soSelected) => {
    try {
      // SET ตัวแปรสำหรับระบุประเภทการเลือก
      setDataType("SO");

      // ล้างข้อมูลเก่าก่อน
      setFormDetailList([]);

      setFormMasterList({
        ...formMasterList,
        refDocId: soSelected.Doc_Id,
        refDoc: soSelected.Doc_No,
        refDocDate: soSelected.Doc_Date,
      });

      if (parseCurrency(soSelected.IsVat) === 1) {
        setIsVatChecked(true);
      }

      // ฟังก์ชันเพื่อสร้างโมเดลใหม่สำหรับแต่ละแถวและคำนวณ itemTotal
      const createNewRow = (index, itemSelected) => {
        return {
          itemCode: itemSelected.Item_Code,
          itemName: itemSelected.Item_Name,
          itemQty: itemSelected.Item_Qty,
          itemUnit: itemSelected.Item_Unit,
          itemPriceUnit: itemSelected.Item_Price_Unit,
          itemTotal: itemSelected.Item_Total,
        };
      };

      // ค้นหาสินค้าในใบขาย
      const soDetailList = await getDataWithComp(
        "API_0702_SO_D",
        `AND Doc_ID = ${soSelected.Doc_ID}`
      );

      // สร้างรายการใหม่โดยการคำนวณจาก soSelected
      const newFormDetails = soDetailList.map((item, index) =>
        createNewRow(formDetailList.length + index, item)
      );

      // อัปเดต formDetailList
      setFormDetailList(newFormDetails);

      handleInvClose();
    } catch (error) {
      getAlert("FAILED", error.message || error);
    }
  };

  const handleRemoveRow = async (index) => {
    setFormDetailList([]);
    setTimeout(() => {
      const newList = formDetailList.filter((_, i) => i !== index);
      setFormDetailList(newList);
    }, 50);
  };

  const handleVatChange = () => {
    setIsVatChecked((prev) => !prev);
  };

  const handleSubmit = async () => {
    try {
      const response = await InvoiceHandleSubmit(
        dataType, // BI = ใบวางบิล, SO = ใบขาย
        formMasterList.arID, // arId
        formMasterList.arCode, // arCode
        formMasterList.arName, // arName
        formMasterList.arTaxNo, // arTaxNo
        formMasterList.arAdd1, // arAdd1
        formMasterList.arAdd2, // arAdd2
        formMasterList.arAdd3, // arAdd3
        formMasterList.arProvince, // arProvince
        formMasterList.arZipcode, // arZipcode
        null, // arContact1
        null, // arContact2
        null, // arTel1
        null, // arTel2
        formMasterList.docDate, // docDate
        formMasterList.docFor, // docFor
        formMasterList.refDocId, // refDocId
        formMasterList.refDoc, // refDoc
        formMasterList.refDocDate, // refDocDate
        formMasterList.docRemark1, // docRemark1
        isVatChecked // isVat
      );

      callInitialize();
      getAlert(response.data.status, response.data.message);
    } catch (error) {
      getAlert("FAILED", error.response?.message || error.message);
    }
  };

  const handleUpdate = async () => {
    try {
      const response = await InvoiceHandleUpdate(formMasterList);
      callInitialize();
      getAlert(response.data.status, response.data.message);
    } catch (error) {
      getAlert("FAILED", error.response?.message || error.message);
    }
  };

  const handleCancel = async () => {
    getAlert("INFO", "Coming Soon");
  };

  // การคำนวณยอดรวม (totalPrice)
  useEffect(() => {
    const total = formDetailList.reduce(
      (acc, item) => acc + (parseCurrency(item.itemTotal) || 0),
      0
    );
    setTotalPrice(total);
  }, [formDetailList]);

  // การคำนวณส่วนลด (receiptDiscount)
  useEffect(() => {
    let discountValue = parseCurrency(formMasterList.discountValue || 0);
    let receiptDiscount = 0;

    if (selectedDiscountValueType === "2") {
      // เปอร์เซ็นต์
      receiptDiscount = (totalPrice / 100) * discountValue;
    } else if (selectedDiscountValueType === "1") {
      // จำนวนเงิน
      receiptDiscount = discountValue;
    }

    setReceiptDiscount(receiptDiscount);
  }, [totalPrice, formMasterList.discountValue, selectedDiscountValueType]);

  // การคำนวณยอดหลังหักส่วนลด (subFinal)
  useEffect(() => {
    const subFinal = totalPrice - receiptDiscount;
    setSubFinal(subFinal);
  }, [totalPrice, receiptDiscount]);

  // การคำนวณ VAT (vatAmount)
  useEffect(() => {
    const vat = isVatChecked ? subFinal * 0.07 : 0;
    setVatAmount(parseCurrency(vat.toFixed(2)));
  }, [subFinal, isVatChecked]);

  // การคำนวณยอดรวมทั้งสิ้น (grandTotal)
  useEffect(() => {
    const grandTotal = subFinal + vatAmount;
    setGrandTotal(parseCurrency(grandTotal));
  }, [subFinal, vatAmount]);

  return (
    <>
      <Breadcrumbs
        page={docNo}
        items={[
          { name: "งานบัญชี", url: "/account" },
          { name: name, url: "/invoice" },
          { name: mode === "U" ? "เรียกดู" + name : "สร้าง" + name, url: "#" },
        ]}
      />
      <div className="hidden-scrollbar" style={{ maxHeight: "auto", overflowY: "auto" }}>
        <div className="body">
          <div class="container-fluid my-4">
            <h5 className="">{name}</h5>
            <div className="row mb-1">
              <div className="col-4">
                <DatePicker
                  label="วันที่เอกสาร"
                  name="docDate"
                  value={formMasterList.docDate}
                  onChange={(date) => handleChangeDateMaster(date, "docDate")}
                  disabled={mode === "U"}
                />
              </div>
              <div className="col-4 text-left">
                <div className="d-flex align-items-center">
                  <label>ลูกค้า</label>
                  <div className="input-group">
                    <input
                      type="text"
                      className="form-control input-spacing"
                      name="apCode"
                      value={
                        (formMasterList.arCode || "") +
                        " " +
                        (formMasterList.arName || "")
                      }
                      onChange={handleChangeMaster}
                      disabled={true}
                    />
                    <button
                      className="btn btn-outline-secondary"
                      onClick={handleArShow}
                      disabled={mode === "U" ? true : false}
                    >
                      <i className="fas fa-search"></i>
                    </button>
                  </div>
                </div>
                <ArModal
                  showArModal={showArModal}
                  handleArClose={handleArClose}
                  arDataList={arDataList}
                  onRowSelectAr={onRowSelectAr}
                />
              </div>
              <div className="col-4">
                <div className="d-flex">
                  <label>สร้างโดย</label>
                  <input
                    type="text"
                    className="form-control input-spacing"
                    value={formMasterList.createdByName}
                    disabled={true}
                  />
                </div>
              </div>
            </div>
            <div className="row mb-1">
              <div className="col-4">
                <div className="d-flex">
                  <label>อ้างอิงเอกสาร</label>
                  <input
                    type="text"
                    className="form-control input-spacing"
                    name="refDoc"
                    value={formMasterList.refDoc || ""}
                    onChange={handleChangeMaster}
                    disabled={true}
                  />
                </div>
              </div>
              <div className="col-4">
                <div className="d-flex align-items-center">
                  <label>ที่อยู่</label>
                  <input
                    type="text"
                    className="form-control input-spacing"
                    name="apAdd1"
                    value={formMasterList.arAdd1 || ""}
                    onChange={handleChangeMaster}
                    disabled={true}
                  />
                </div>
              </div>
              <div className="col-4">
                <div className="d-flex">
                  <label className="">วันที่สร้าง</label>
                  <input
                    type="text"
                    className="form-control input-spacing"
                    value={formMasterList.createdDate}
                    disabled={true}
                  />
                </div>
              </div>
            </div>
            <div className="row mb-1">
              <div className="col-4">
                <DatePicker
                  label="วันที่เอกสารอ้างอิง"
                  name="refDocDate"
                  value={formMasterList.refDocDate}
                  onChange={(date) => handleChangeDateMaster(date, "refDocDate")}
                  disabled={true}
                />
              </div>
              <div className="col-4">
                <div className="d-flex align-items-center">
                  <label></label>
                  <input
                    type="text"
                    className="form-control input-spacing"
                    value={
                      (formMasterList.arAdd2 || "") +
                      " " +
                      (formMasterList.arAdd3 || "")
                    }
                    disabled={true}
                  />
                </div>
              </div>
            </div>
            <div className="row mb-1">
              <div className="col-4">
                <div className="d-flex">
                  <label>หมายเหตุ</label>
                  <input
                    type="text"
                    className="form-control input-spacing"
                    name="docRemark1"
                    value={formMasterList.docRemark1 || ""}
                    onChange={handleChangeMaster}
                    disabled={false}
                  />
                </div>
              </div>
              <div className="col-4">
                <div className="d-flex align-items-center">
                  <label></label>
                  <input
                    type="text"
                    className="form-control input-spacing"
                    value={
                      (formMasterList.arProvince || "") +
                      " " +
                      (formMasterList.arZipcode || "")
                    }
                    disabled={true}
                  />
                </div>
              </div>
            </div>
            <div className="row mb-1">
              <div className="col-4" />
              <div className="col-4">
                <div className="d-flex align-items-center">
                  <label>เลขที่ภาษี</label>
                  <input
                    type="text"
                    className="form-control input-spacing"
                    value={formMasterList.arTaxNo || ""}
                    disabled={true}
                  />
                </div>
              </div>
            </div>
            <div className="row mb-1">
              <div className="col-4">
                {/* <div className="d-flex">
              <label>ไปคลัง :</label>
              <select
                class="form-select"
                value={selectedWarehouseTo}
                onChange={(e) => handleChangeWarehouse(e.target.value, 'TO')}>
                <option value={null}>
                  กรุณาระบุคลัง
                </option>
                {whToDataList.map((warehouse) => (
                  <option
                    key={warehouse.WH_Id}
                    value={warehouse.WH_Id}
                  >
                    {warehouse.WH_Code} ({warehouse.WH_Name})
                  </option>
                ))}
              </select>
            </div> */}
              </div>
              <div className="col-4">
                {/* <div className="d-flex">
              <label>หมายเหตุ : </label>
              <input
                type="text"
                className="form-control input-spacing"
                name="docRemark1"
                value={formMasterList.docRemark1 || ''}
                onChange={handleChangeMaster}
                disabled={false} />
            </div> */}
              </div>
            </div>
          </div>
          <hr />
        </div>
        <div className="container-fluid my-3">
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <h4 className="card-title">รายละเอียดสินค้า</h4>
                  <button
                    className="btn text-white mx-3"
                    onClick={handleInvShow}
                    style={{
                      backgroundColor: "rgb(239, 108, 0)",
                      whiteSpace: "nowrap",
                      padding: "10px",
                      fontSize: "15px",
                    }}
                    disabled={formMasterList.arID === null ? true : false}
                  >
                    <i className="fa fa-plus"></i> เพิ่มรายการ
                  </button>
                  <InvoiceModal
                    showInvModal={showInvModal}
                    handleInvClose={handleInvClose}
                    onRowSelectInv={onRowSelectInv}
                    onRowSelectSo={onRowSelectSo}
                    invDataList={invDataList}
                    soDataList={soDataList}
                    arId={formMasterList.arID}
                  />
                </div>
                <div className="card-body">
                  <div
                    className="table-responsive"
                    style={{ maxHeight: "500px", overflowY: "auto" }}
                  >
                    {/* Table สำหรับใบวางบิล */}
                    {dataType === "BI" && (
                      <table
                        id="basic-datatables"
                        className="table table-striped table-hover"
                      >
                        <thead className="thead-dark">
                          <tr>
                            <th className="text-center" style={{ width: "2%" }}>
                              #
                            </th>
                            <th className="text-center" style={{ width: "8%" }}>
                              วันที่
                            </th>
                            <th
                              className="text-center"
                              style={{ width: "10%" }}
                            >
                              เลขที่เอกสาร
                            </th>
                            <th
                              className="text-center"
                              style={{ width: "50%" }}
                            >
                              ชื่อรายการ
                            </th>
                            <th
                              className="text-center"
                              style={{ width: "10%" }}
                            >
                              จำนวน
                            </th>
                            <th
                              className="text-center"
                              style={{ width: "15%" }}
                            >
                              รวมราคา
                            </th>
                            <th className="text-center" style={{ width: "5%" }}>
                              ลบ
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {formDetailList.length > 0 ? (
                            formDetailList.map((item, index) => (
                              <tr key={item.itemId || index}>
                                <td className="text-center">{index + 1}</td>
                                <td className="text-center">
                                  {formatDate(item.docDate) || "-"}
                                </td>
                                <td className="text-center">
                                  {item.docNo || "-"}
                                </td>
                                <td className="text-left">
                                  {item.docName || "-"}
                                </td>
                                <td className="text-center">
                                  {item.itemQty || "-"}
                                </td>
                                <td className="text-end">
                                  {item.itemTotal
                                    ? formatCurrency(item.itemTotal)
                                    : "-"}
                                </td>
                                <td className="text-center">
                                  <button
                                    type="button"
                                    className="btn btn-danger"
                                    onClick={() => handleRemoveRow(index)}
                                  >
                                    ลบ
                                  </button>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="7" className="text-center">
                                <h5>ไม่พบรายการใบวางบิล</h5>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    )}
                    {/* Table สำหรับใบขาย */}
                    {dataType === "SO" && (
                      <>
                        <table
                          id="basic-datatables"
                          className="table table-striped table-hover"
                        >
                          <thead className="thead-dark">
                            <tr>
                              <th
                                className="text-center"
                                style={{ width: "2%" }}
                              >
                                #
                              </th>
                              <th
                                className="text-center"
                                style={{ width: "10%" }}
                              >
                                รหัสสินค้า
                              </th>
                              <th
                                className="text-center"
                                style={{ width: "43%" }}
                              >
                                ชื่อสินค้า
                              </th>
                              <th
                                className="text-center"
                                style={{ width: "10%" }}
                              >
                                จำนวน
                              </th>
                              <th
                                className="text-center"
                                style={{ width: "10%" }}
                              >
                                หน่วย
                              </th>
                              <th
                                className="text-center"
                                style={{ width: "10%" }}
                              >
                                ราคาต่อหน่วย
                              </th>
                              <th
                                className="text-center"
                                style={{ width: "10%" }}
                              >
                                รวมราคา
                              </th>
                              <th
                                className="text-center"
                                style={{ width: "5%" }}
                              >
                                ลบ
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {currentItems.length > 0 ? (
                              currentItems.map((item, index) => (
                                <tr key={item.itemId || index}>
                                  <td className="text-center">{index + 1}</td>
                                  <td className="text-center">
                                    {item.itemCode || "-"}
                                  </td>
                                  <td className="text-left">
                                    {item.itemName || "-"}
                                  </td>
                                  <td className="text-center">
                                    {item.itemQty || "-"}
                                  </td>
                                  <td className="text-center">
                                    {item.itemUnit || "-"}
                                  </td>
                                  <td className="text-end">
                                    {item.itemPriceUnit
                                      ? formatCurrency(item.itemPriceUnit)
                                      : "-"}
                                  </td>
                                  <td className="text-end">
                                    {item.itemTotal
                                      ? formatCurrency(item.itemTotal)
                                      : "-"}
                                  </td>
                                  <td className="text-center">
                                    <button
                                      type="button"
                                      className="btn btn-danger"
                                      onClick={() => handleRemoveRow(index)}
                                    >
                                      ลบ
                                    </button>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="8" className="text-center">
                                  <h5>ไม่พบรายการสินค้าใบขาย</h5>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>

                        {/* Pagination */}
                        <nav>
                          <ul className="pagination justify-content-center">
                            {Array.from(
                              {
                                length: Math.ceil(
                                  formDetailList.length / itemsPerPage
                                ),
                              },
                              (_, index) => (
                                <li
                                  key={index + 1}
                                  className={`page-item ${currentPage === index + 1 ? "active" : ""
                                    }`}
                                >
                                  <button
                                    className="page-link"
                                    onClick={() => paginate(index + 1)}
                                  >
                                    {index + 1}
                                  </button>
                                </li>
                              )
                            )}
                          </ul>
                        </nav>
                      </>
                    )}
                    {/* Table เมื่อ dataType เป็นค่าว่าง */}
                    {dataType === "" && (
                      <table
                        id="basic-datatables"
                        className="table table-striped table-hover"
                      >
                        <thead className="thead-dark">
                          <tr>
                            <th className="text-center" style={{ width: "2%" }}>
                              #
                            </th>
                            <th className="text-center" style={{ width: "8%" }}>
                              วันที่
                            </th>
                            <th
                              className="text-center"
                              style={{ width: "10%" }}
                            >
                              เลขที่เอกสาร
                            </th>
                            <th
                              className="text-center"
                              style={{ width: "50%" }}
                            >
                              ชื่อรายการ
                            </th>
                            <th
                              className="text-center"
                              style={{ width: "10%" }}
                            >
                              จำนวน
                            </th>
                            <th
                              className="text-center"
                              style={{ width: "15%" }}
                            >
                              รวมราคา
                            </th>
                            <th className="text-center" style={{ width: "5%" }}>
                              ลบ
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td colSpan="7" className="text-center">
                              <h5>ไม่พบรายการ</h5>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    )}
                  </div>
                </div>
              </div>
              <Summary
                formMasterList={formMasterList}
                handleChangeMaster={handleChangeMaster}
                selectedDiscountValueType={selectedDiscountValueType}
                handleCheckboxChange={handleCheckboxChange}
                receiptDiscount={receiptDiscount}
                formatCurrency={formatCurrency}
                totalPrice={totalPrice}
                subFinal={subFinal}
                isVatChecked={isVatChecked}
                handleVatChange={handleVatChange}
                vatAmount={vatAmount}
                grandTotal={grandTotal}
                disabled={false}
              />
            </div>
          </div>
        </div>
      </div>
      <FormAction
        onSubmit={handleSubmit}
        onUpdate={handleUpdate}
        onCancel={handleCancel}
        mode={mode}
        setMode={setMode}
        footer={true}
      />
    </>
  );
};

export default Form;
